import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import zrcheader from '@/components/zrcheader/index.vue';
import zrcfooter from '@/components/zrcfooter/index.vue';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  name: 'ProjectdetailView',
  components: {
    zrcheader,
    zrcfooter
  },
  data() {
    return {
      id: 0,
      zrctoken: '',
      projectinfo: {
        title: '',
        sample: '',
        introduce: '',
        question: '',
        image: ''
      },
      xztitlenum: 1,
      project_dingdan_list: [],
      projectlist: [],
      loadingStatus: true,
      xzmenu: 2 //菜单选中
    };
  },
  created() {
    var that = this;
    this.getParams();
    setTimeout(() => {
      this.loadingStatus = false;
    }, 2000);
  },
  onLoad(option) {
    console.log('参数');
  },
  watch: {
    '$route'(to, from) {
      // 在mounted函数执行的方法，放到该处
      // 加载页面数据的方法
      var that = this;
      console.log(to.query);
      that.id = to.query.id || 1;
      that.xzmenu = that.numToStr(to.query.xzmenu) || 1;
      that.get_project_details(); //获取指定项目的信息
    }
  },
  methods: {
    getParams() {
      var that = this;
      // 取到路由带过来的参数
      console.log(that.$route.query);
      const option = this.$route.query;
      that.id = option.id || 1;
      that.xzmenu = that.numToStr(option.xzmenu) || 1;
    },
    numToStr(num) {
      num = num.toString();
      return num;
    },
    //获取指定项目的信息
    get_project_details: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'project_details',
        q: {
          id: that.$data.id
        }
      }, URL);
      baseGet(url, function (res) {
        that.projectinfo = res.data.info.projectinfo;
        that.project_dingdan_list = res.data.info.project_dingdan_list;
        that.projectlist = res.data.info.projectlist;
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //进入到具体的项目内容
    goprojectdetail: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/projectdetail',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    },
    //进入到具体的项目下单
    goprojectdingdan: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/projectdingdan',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    }
  },
  mounted: function () {
    var that = this;
    that.get_project_details(); //获取指定项目的信息
  }
};